/**
 *
 * @author Giovanni Grandinetti <g.grandinetti@adiacent.com>
 *
 */
import { sessionStorageUtil } from "../_foundation/utils/storageUtil";
import {
  IMAGE_ASSET_BASE_URL,
  ATTACHMENT_ASSET_BASE_URL,
  IMAGE_ATTACHMT_URL_REWRITE_MRO_ASSET_ENABELD,
} from "../constants/common";

const commonUtil = {

  // CR022 Autodesk Vault (WS4) - whether product images/attachments should be rewritten
  // through the AssetHandler proxy, gated by the IMAGE_ATTACHMT_URL_REWRITE_MRO_ASSET_ENABELD
  // public XStoreConf flag (acts as a kill switch when not "1").
  isAssetUrlRewriteEnabled: (): boolean => {
    const flag = sessionStorageUtil.get(IMAGE_ATTACHMT_URL_REWRITE_MRO_ASSET_ENABELD);
    return flag ? flag === "1" : false;
  },

  isValidHttpUrl(str) {
    try {
      const url = new URL(str);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  },
  // Resolves a raw PIM media token (e.g. product.thumbnailRaw/fullImageRaw) into a URL
  // streamed through the AssetHandler image proxy.
  toAssetImageUrl: (rawToken: string): string => {
    if (!rawToken) return "";
    const url = rawToken.replace("hclstore/FerreroCAS/", "");
    if (commonUtil.isValidHttpUrl(url)) return url;
    return commonUtil.isAssetUrlRewriteEnabled() ? IMAGE_ASSET_BASE_URL + url : url;
  },

  // Resolves an attachmentAssetID into a URL streamed through the AssetHandler
  // attachment proxy; when the rewrite is disabled, falls back to the raw
  // (un-prefixed) attachment path instead of the proxy URL.
  toAttachmentAssetUrl: (attachmentAssetId: string, attachmentAssetPathRaw: string): string => {
    if (!attachmentAssetId || !attachmentAssetPathRaw) return "";
    return commonUtil.isAssetUrlRewriteEnabled()
      ? ATTACHMENT_ASSET_BASE_URL + attachmentAssetId
      : attachmentAssetPathRaw;
  },

  randomNumFixDigit: (n: number):number  => {
    const min = n <= 1 ? 1 : Math.pow(10, n);
    const max = n <= 1 ? 10 : Math.pow(10, n + 1);
    return Math.floor(Math.random() * (max - min)) + min;
  },

  shallowObjectEqual: (object1: object, object2: object): boolean => {

    if( (object1 === null  || typeof(object1) === undefined) && 
          (object2 === null  || typeof(object2) === undefined) ) return true;

    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (object1[key] !== object2[key]) {
        return false;
      }
    }
    return true;
  },
  

}

export default commonUtil;